import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ScnackbarData, SnackbarStyles, ToastService } from '../../../../commons/toast.service';
import { NuevaTarea, AccionTarea } from '../../../../models/Tarea';
import { TareaService } from '../../../../services/tarea.service';
import { AvanceComponent } from '../avance/avance.component';
import { UtilService } from '../../../../services/util.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
    selector: 'app-cancelar',
    imports: [
        MatDialogModule, MatDialogActions, MatDialogClose, MatDialogContent,
        MatButtonModule, MatIconModule,
        FormsModule, ReactiveFormsModule, MatFormFieldModule,
        MatInputModule,
        MatProgressSpinnerModule
    ],
    templateUrl: './cancelar.component.html',
    styleUrl: './cancelar.component.scss'
})
export class CancelarComponent {
  readonly dialogRef = inject(MatDialogRef<AvanceComponent>);
  readonly data = inject<NuevaTarea>(MAT_DIALOG_DATA);
  utilService = inject(UtilService)
  nuevaTarea: NuevaTarea

  cancelarForm = new FormGroup({
    comentario: new FormControl("", {
      validators: [Validators.required]
    })
  })

  fetchingCancelarTarea = false

  snackbarData: ScnackbarData = {}

  constructor(
    private tareaService: TareaService,
    private toast: ToastService,
    private authService: AuthService,
  ) {
    this.nuevaTarea = structuredClone(this.data)
  }

  onSubmitForm() {
    this.fetchingCancelarTarea = true
    const formControls = this.cancelarForm.controls
    const userID = this.authService.getTokenData()!.id;
    const accionTareas: AccionTarea[] = [
      {
        id: this.nuevaTarea.id,
        idParticipante: parseInt(userID),
        comentario: formControls.comentario.value!,
        fechaExpira: this.nuevaTarea.fechaExpira
      }
    ]
    this.tareaService.cancelarTarea(accionTareas).subscribe({
      next: (_) => {
        this.snackbarData.message = "Tarea cancelada"
        this.snackbarData.style = SnackbarStyles.Success
        this.snackbarData.iconName = "check_circle"
        this.fetchingCancelarTarea = false
        this.toast.show(this.snackbarData)
        this.utilService.callTasks();
        this.dialogRef.close({ success: true })
      },
      error: (_) => {
        this.snackbarData.message = "Error cancelando tarea"
        this.snackbarData.style = SnackbarStyles.Error
        this.snackbarData.iconName = "error"
        this.fetchingCancelarTarea = false
        this.toast.show(this.snackbarData)
        this.dialogRef.close({ success: false })
      }
    })
  }

}
